import { createContext } from 'react';
import { IConfig } from './IConfig';

export const ConfigContext = createContext({} as IConfig);
